import React from 'react';
import _ from 'lodash';
// ...existing code...
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { blocks } from '~/config';
// ...existing code...
import {
  getBlocksFieldname,
  getBlocksLayoutFieldname,
} from '@plone/volto/helpers';
import moment from 'moment';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import { Helmet } from '@plone/volto/helpers';
import { connect, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { MediaQueryConfig } from '../../../helpers/GlobalStyle/GlobalStyle';
import { flattenToAppURL } from '@plone/volto/helpers';
// ...existing code...
import './Common.css';

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
});

/**
 * Research folder header component class.
 * @function ResearchFolderHeader
 * @param {Object} title String.
 * @returns {string} Markup of the component.
 */

const DefaultBody = injectIntl(({ content, intl }) => {
  const blocksFieldname = getBlocksFieldname(content);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(content);
  return (
    <div>
      {map(content[blocksLayoutFieldname].items, (block) => {
        const blockType =
          blocks.blocksConfig[content[blocksFieldname]?.[block]?.['@type']];
        const isTitle = blockType?.['id'] === 'title';
        if (isTitle) {
          return null;
        }
        const Block = blockType?.['view'] || null;
        return Block !== null ? (
          <Block
            key={block}
            id={block}
            properties={content}
            data={content[blocksFieldname][block]}
          />
        ) : (
          <div key={block}>
            {intl.formatMessage(messages.unknownBlock, {
              block: content[blocksFieldname]?.[block]?.['@type'],
            })}
          </div>
        );
      })}
    </div>
  );
});

const FolderTitle = ({ title, title_sp1, title_sp2 }) => {
  const isSP = useMediaQuery({
    query: MediaQueryConfig.SP_AND_TABLET,
  });
  return (
    <h2 className="title">
      {isSP ? (
        title_sp1 && title_sp2 ? (
          <>
            {title_sp1}
            <br />
            {title_sp2}
          </>
        ) : (
          title && title
        )
      ) : (
        title && title
      )}
    </h2>
  );
};

const FolderLeadSentence = ({
  lead_sentence,
  lead_sentence_sp1,
  lead_sentence_sp2,
}) => {
  const isSP = useMediaQuery({
    query: MediaQueryConfig.SP_AND_TABLET,
  });
  return (
    <h3 className="subtitle">
      {isSP ? (
        lead_sentence_sp1 && lead_sentence_sp2 ? (
          <>
            {lead_sentence_sp1}
            <br />
            {lead_sentence_sp2}
          </>
        ) : (
          lead_sentence && lead_sentence
        )
      ) : (
        lead_sentence && lead_sentence
      )}
    </h3>
  );
};

const HelmetTitle = ({ pageTitle }) => {
  const [data, layout, locale, opening_img_pc, siteTitle] = useSelector(
    (state) => {
      const locale = state?.content?.data?.language?.token ?? 'ja';
      const siteMainInfoAttr = state?.siteMainInfo?.result?.data?.attributes;
      return [
        state?.content?.data,
        state?.content?.data?.layout,
        locale,
        siteMainInfoAttr?.locale[locale]?.header?.opening_img_pc,
        siteMainInfoAttr?.locale[locale]?.assets?.site_title,
      ];
    },
  );
  const RESOU_URL = 'https://resou.osaka-u.ac.jp';
  const OG_IMAGE_TYPES = [
    'ResearchView',
    'StoryView',
    'FeatureView',
    'FeatureFolderView',
  ];
  const title = `${pageTitle} - ${siteTitle}`;
  const desc = data?.meta_description ?? data?.description;
  const ogUrl = `${RESOU_URL}${flattenToAppURL(_.get(data, '@id'))}`;
  const ogLocale = locale === 'en' ? 'en_US' : 'ja_JP';
  function og_image() {
    if (OG_IMAGE_TYPES.includes(layout)) {
      return `${RESOU_URL}${flattenToAppURL(
        data?.title_image_sp?.download ||
          '/assets/images/nowprinting_580_280.jpg',
      )}`;
    } else {
      return `${RESOU_URL}${flattenToAppURL(opening_img_pc?.src)}`;
    }
  }
  const ogType = layout === 'LanguageRootFolderView' ? 'website' : 'article';

  return (
    <Helmet
      title={title}
      meta={[
        { name: 'description', content: desc },
        { name: 'google', content: 'notranslate' },
        { property: 'og:title', content: pageTitle },
        { property: 'og:description', content: desc },
        { property: 'og:url', content: ogUrl },
        { property: 'og:locale', content: ogLocale },
        { property: 'og:image', content: og_image() },
        { property: 'og:type', content: ogType },
        { property: 'og:site_name', content: siteTitle },
      ]}
    />
  );
};

const LabelFeatureComponent = ({ locale }) => {
  return (
    <Link to={`/${locale}/feature`}>
      <div className="LabelFeature">
        <FormattedMessage id="Label Feature" defaultMessage="feature" />
      </div>
    </Link>
  );
};

export const HorizontalRule = (props) => {
  if (props.className) {
    return <hr className={`HorizontalRule ${props.className}`} />;
  } else {
    return <hr className="HorizontalRule" />;
  }
};

const SNSShare = ({ content }) => {
  const url = 'https://resou.osaka-u.ac.jp' + flattenToAppURL(content['@id']);
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`;
  return (
    <div className="SNSShare">
      <a
        href={facebookShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
        className="SNSShare__button SNSShare__facebook"
        title="Facebookでシェア"
      >
        {/* Facebook SVGアイコン */}
        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="22.5" cy="22.5" r="22.5" fill="#1877F3" />
          <path d="M29.5 23.25H25.5V35H20.5V23.25H18V19.5H20.5V17.5C20.5 15.0147 22.5147 13 25 13H29V16.75H27C26.4477 16.75 26 17.1977 26 17.75V19.5H29L28.5 23.25Z" fill="white" />
        </svg>
      </a>
      <a
        href={twitterShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on X"
        className="SNSShare__button SNSShare__x"
        title="Xでシェア"
      >
        {/* X (旧Twitter) SVGアイコン */}
        <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="22.5" cy="22.5" r="22.5" fill="#222" />
          <g fill="#fff" transform="translate(11,11) scale(0.018)">
            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"/>
          </g>
        </svg>
      </a>
    </div>
  );
};

const en_options = { year: 'numeric', month: 'short', day: 'numeric' };

const zeroSuppledDate = (locale, dt) => {
  if (dt != null) {
    if (locale === 'ja') {
      return moment(dt).format('YYYY-M-D');
    } else {
      var event = new Date(dt);
      return event.toLocaleDateString('en-US', en_options);
    }
  }
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

/*ResouFolderHeader.propTypes = {
  title: PropTypes.string.isRequired,
};*/

const LabelFeature = connect(
  (state, props) => {
    return {
      locale: state?.content?.data?.language?.token ?? 'ja',
    };
  },
  (dispatch, props) => {
    return {};
  },
)(LabelFeatureComponent);

//export default injectIntl(HelmetTitleContainer, {});

export {
  DefaultBody,
  FolderTitle,
  FolderLeadSentence,
  HelmetTitle,
  LabelFeature,
  SNSShare,
  zeroSuppledDate,
};
